import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Phone, CreditCard, Wallet, Plug } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const META = {
  ringcentral: { name: "RingCentral", desc: "Telephony — click-to-call, call logging & inbound lead capture.", icon: Phone },
  stripe: { name: "Stripe", desc: "Card payments & subscription billing for software licenses.", icon: CreditCard },
  paypal: { name: "PayPal", desc: "Alternative checkout & invoicing for global customers.", icon: Wallet },
};

export default function Integrations() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/integrations").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const connect = async (provider) => {
    const { data } = await api.post(`/integrations/${provider}/connect`);
    toast.info(data.message);
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-heading font-bold tracking-tight">Integrations</h1>
        <p className="text-muted-foreground mt-1">Backend hooks are ready — connect telephony & payments in the next phase.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((r) => {
          const m = META[r.provider] || { name: r.provider, desc: "", icon: Plug };
          const Icon = m.icon;
          const connected = r.status !== "not_connected";
          return (
            <div key={r.provider} className="rounded-sm border border-border bg-card p-6 flex flex-col h-full" data-testid={`integration-${r.provider}`}>
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-sm bg-primary/10 text-primary flex items-center justify-center"><Icon size={20} /></div>
                <Badge variant="outline" className={`rounded-sm ${connected ? "bg-warning/15 text-warning border-warning/30" : ""}`}>
                  {r.status === "pending_setup" ? "Pending Setup" : "Not Connected"}
                </Badge>
              </div>
              <h3 className="font-heading font-semibold text-lg mt-4">{m.name}</h3>
              <p className="text-sm text-muted-foreground mt-1 flex-1">{m.desc}</p>
              <p className="text-xs text-muted-foreground mt-3 uppercase tracking-wide">{r.category}</p>
              <Button variant="outline" className="rounded-sm mt-4 w-full" onClick={() => connect(r.provider)} data-testid={`connect-${r.provider}`}>
                {connected ? "Configure" : "Connect"}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
